// extracted by mini-css-extract-plugin
var _1 = "Task_button__nPMMB";
var _2 = "Task_buttonCard__inpga";
var _3 = "Task_checkbox__Hq11x";
var _4 = "Task_contentHoverable__pRz3W";
var _5 = "Task_dueDate__fYYk2";
var _6 = "Task_dueDateCard__-UUNF";
var _7 = "Task_icon__uWr1i";
var _8 = "Task_itemCompleted__1Bs8O";
var _9 = "Task_member__GYsXw";
var _a = "Task_members__2lA35";
var _b = "Task_moreMembers__KwuZv";
var _c = "Task_moreMembersCard__O5gaM";
var _d = "Task_target__6Z+FV";
var _e = "Task_task__j-4kw";
var _f = "Task_taskCompleted__Vb26q";
var _10 = "Task_taskEditable__Tl0dl";
var _11 = "Task_wrapper__iYyQq";
export { _1 as "button", _2 as "buttonCard", _3 as "checkbox", _4 as "contentHoverable", _5 as "dueDate", _6 as "dueDateCard", _7 as "icon", _8 as "itemCompleted", _9 as "member", _a as "members", _b as "moreMembers", _c as "moreMembersCard", _d as "target", _e as "task", _f as "taskCompleted", _10 as "taskEditable", _11 as "wrapper" }
